// proto3 JSON omits zero-valued scalars, so a count, rate or bps that is 0
// arrives as a missing field. num() reads any response number — including
// int64s, which proto3 JSON sends as strings — and returns 0 when it is
// missing or not a number.
export function num(v: unknown): number {
  const n = typeof v === 'string' && v.trim() !== '' ? Number(v) : v;
  return typeof n === 'number' && Number.isFinite(n) ? n : 0;
}
